// 总的
import CBLayout from './CBLayout';
import CBRLayout from './CBRLayout';
import CRBLayout from './CRBLayout';
import CRLayout from './CRLayout';
import LBCLayout from './LBCLayout';
import LCBLayout from './LCBLayout';
import LCLayout from './LCLayout';
import LCRBLayout from './LCRBLayout';
import LCRLayout from './LCRLayout';
import LRTCBLayout from './LRTCBLayout';
import LTCBLayout from './LTCBLayout';
import LTCLayout from './LTCLayout';
import TBLCRLayout from './TBLCRLayout';
import TCBLayout from './TCBLayout';
import TCBRLayout from './TCBRLayout';
import TCLayout from './TCLayout';
import TCRLayout from './TCRLayout';
import TLCLayout from './TLCLayout';
import TLRCLayout from './TLRCLayout';
import TRCLayout from './TRCLayout';
export { CBLayout, CBRLayout, CRBLayout, CRLayout, LBCLayout, LCBLayout, LCLayout, LCRBLayout, LCRLayout, LRTCBLayout, LTCBLayout, LTCLayout, TBLCRLayout, TCBLayout, TCBRLayout, TCLayout, TCRLayout, TLCLayout, TLRCLayout, TRCLayout };